import React, { useState } from 'react';
import ScrollTop from '../components/global-components/BackToTop';
import Footer from '../components/global-components/Footer';
import Indicators from '../components/section-components/Indicators';
import Service from '../components/section-components/Service';
import Layouts from '../components/global-components/Layouts';
import MisVis from '../components/section-components/MisVis';
import About from '../components/section-components/About';
import { usePageData } from '../data/usePageData';
import HeaderV2 from '../components/section-components/Header-v2';

const Home = () => {
    const { pageData } = usePageData();
    const [isLoading, setIsLoading] = useState(true);

    const handleImageLoad = () => {
        setIsLoading(false);
    };

    return (
        <>
                <HeaderV2 pageData={pageData} handleImageLoad={handleImageLoad} title={""} size='450px' />
                {isLoading ? (
                    <div className="preloader">
                        <div className="main-circle">
                            <div className="green-circle">
                                <div className="brown-circle">

                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <About pageData={pageData} />
                        <div className='section-title' style={{ paddingLeft: "70px", paddingRight: "70px", }}>
                            <hr></hr>
                        </div>
                        <MisVis pageData={pageData} />
                        <Service />
                        <Indicators />
                        <Footer />
                    </>
                )}
        </>
    );
};

export default Home;
